import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
//import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Transition from '../dialogs/Transition';
import FormSelect from '../form/FormSelect';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

import _ from 'lodash';
//import FormText from "../form/FormText";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
//import {Link} from "react-router-dom";
//import EquipmentSelect from "../advancedForm/EquipmentSelect";
///import ShiftSelect from "../advancedForm/ShiftSelect";
//import FormTimePicker from "../form/FormTimePicker";
import { post } from '../../modules/utility';
import FormTextArea from '../form/FormTextArea';
import Note from '../Note';
import Badge from '@material-ui/core/Badge';

import { statuses } from './WorkDayStatuses';
//import FormCheckbox from "../form/FormCheckbox";

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';
import FormTextNoEdit from '../form/FormTextNoEdit';

const isWorkingStatusMap = {};
statuses.forEach(({ value, isWorking }) => {
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
});

function TabPanel(props) {
	const { children } = props;

	return (
		<div style={{ paddingTop: 20, paddingLeft: 10, paddingRight: 10 }}>
			<Box>{children}</Box>
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 30,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		noNotes: {
			color: '#999',
			textTransform: 'italic',
		},
		dateNote: {
			color: '#666',
			fontSize: 14,
		},
		noteContainer: {
			paddingBottom: 5,
			borderBottom: '1px solid #f5f5f5',
			marginBottom: 5,
		},
		badgeMargin: {
			paddingRight: 10,
		},
		noteBadge: {
			backgroundColor: '#00BCD4',
		},
		activityBadge: {
			backgroundColor: '#9C27B0',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
	};
}

class MaintenanceUpdateDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			selectedTabValue: 0,
			isSaving: false,
			savingSuccessful: false,

			isSavingNote: false,
			savingNoteSuccessful: false,

			isSavingMaintenance: false,
			savingMaintenanceSuccessful: false,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { unavailableTruck } = this.props;

		if (unavailableTruck !== prevProps.unavailableTruck) {
			const { equipmentId, status, note } = unavailableTruck;

			let maintenanceEquipmentId = equipmentId;
			let maintenanceStatus = 'operational';
			let maintenanceNote = undefined;

			if (status) {
				maintenanceStatus = status;
			}
			if (note) {
				maintenanceNote = note;
			}

			this.setState({
				maintenanceEquipmentId,
				maintenanceStatus,
				maintenanceNote,
			});
		}
	}

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	submitAddMaintenance = () => {
		const { unavailableTruck, showErrors, onRefreshData } = this.props;

		this.setState({ isSavingMaintenance: true, savingMaintenanceSuccessful: false });
		const { date } = unavailableTruck;

		const { maintenanceEquipmentId, maintenanceStatus, maintenanceNote } = this.state;

		const params = {
			equipmentId: maintenanceEquipmentId,
			eventDate: date,
			status: maintenanceStatus,
			note: maintenanceNote,
		};

		post({
			method: 'equipmentOverride.add',
			params,
			callback: (err) => {
				if (err) {
					this.setState({ isSavingMaintenance: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSavingMaintenance: false,
						savingMaintenanceSuccessful: true,
					});

					onRefreshData();

					_.delay(() => {
						this.setState({ savingMaintenanceSuccessful: false });
					}, 2000);
				}, 400);
			},
		});
	};

	handleTabChange = (event, selectedTabValue) => {
		this.setState({ selectedTabValue });
	};

	handleChangeIndex = (index) => {
		this.setState({ index });
	};

	render() {
		const {
			open,
			onClose,
			unavailableTruck,
			date,
			classes,
			equipmentMap,
			overrides = [], //- TODO not sent
		} = this.props;

		const { selectedTabValue } = this.state;

		if (!unavailableTruck) {
			return (
				<Dialog open={open} TransitionComponent={Transition} onClose={onClose}>
					<div className={classes.inner}>Sorry missing unavailableTruck. Please refresh???</div>
				</Dialog>
			);
		}

		const { equipmentId } = unavailableTruck;

		const dateFormatted = moment(date).format('MMM Do');
		const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
		/** @namespace equipment.geoTabComment **/
		const equipmentDisplay = `${equipment.display} ${equipment.geoTabComment}`;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							<span>{dateFormatted}</span> - <strong>{equipmentDisplay}</strong>
						</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>
					<Tabs
						value={selectedTabValue}
						indicatorColor="primary"
						textColor="primary"
						onChange={this.handleTabChange}
						style={{ borderBottom: '1px solid #eee' }}
					>
						<Tab label="Maintenance / Issue" />
						<Tab
							label={
								<Badge
									badgeContent={overrides.length}
									className={classes.badgeMargin}
									color="primary"
									classes={{ colorPrimary: classes.activityBadge }}
								>
									Activity
								</Badge>
							}
						/>
					</Tabs>

					<SwipeableViews
						//axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
						index={selectedTabValue}
						onChangeIndex={this.handleChangeIndex}
					>
						<TabPanel value={selectedTabValue} index={3}>
							{this.renderMaintenance()}
						</TabPanel>
						<TabPanel value={selectedTabValue} index={2}>
							{this.renderActivity()}
						</TabPanel>
					</SwipeableViews>
				</div>
			</Dialog>
		);
	}

	//- TODO
	renderActivity = () => {
		const { classes, userMap, equipmentMap, shiftMap } = this.props;
		const overrides = [];

		return (
			<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
				<Grid item xs={12}>
					{_.isEmpty(overrides) && (
						<div className={classes.noNotes}>
							<i>No activity</i>
						</div>
					)}

					{!_.isEmpty(overrides) && (
						<div>
							{overrides.map((workDayOverride) => {
								const {
									workDayOverrideId,
									status,
									equipmentId,
									shiftId,
									shiftTime,
									creatorUserId,
									dateCreated,
								} = workDayOverride;

								const creatorUser = userMap[creatorUserId] || {
									firstName: 'Missing',
									lastName: '',
								};
								const dateFormatted = moment(dateCreated).format('M/D h:mm a');

								const changes = [];
								//- TODO status display
								if (status) {
									changes.push(`status to ${status}`);
								}
								if (equipmentId) {
									const equipment = equipmentMap[equipmentId] || { display: 'missing' };
									changes.push(`truck to ${equipment.display}`);
								}

								if (shiftId) {
									const shift = shiftMap[shiftId] || { display: 'missing' };
									changes.push(`shift to ${shift.display}`);
								}

								if (shiftTime) {
									changes.push(`start time to  ${moment(shiftTime, 'HH:mm:ss').format('h:mm a')}`);
								}

								return (
									<div className={classes.noteContainer} key={workDayOverrideId}>
										<div>
											<strong>
												{creatorUser.firstName} {creatorUser.lastName}{' '}
											</strong>
											changed {changes.join(', ')}
										</div>
										<div className={classes.dateNote}>{dateFormatted}</div>
									</div>
								);
							})}
						</div>
					)}
				</Grid>
			</Grid>
		);
	};

	renderMaintenance = () => {
		const { classes, equipmentMap } = this.props;
		const {
			isSavingMaintenance,
			maintenanceEquipmentId,
			savingMaintenanceSuccessful,
			maintenanceStatus,
		} = this.state;

		const equipment = equipmentMap[maintenanceEquipmentId] || { display: 'Missing' };

		return (
			<form>
				<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
					<Grid item xs={12}>
						<Note label={'Used to keep track what trucks are out for maintenance / issues.'} />
					</Grid>

					<FormTextNoEdit
						{...this.getInputProps('equipmentDisplay')}
						value={equipment.display}
						label={'Truck'}
					/>

					<FormSelect
						{...this.getInputProps('maintenanceStatus')}
						label={'Maintenance Status'}
						options={[
							{ display: 'Operational', value: 'operational' },
							{ display: 'Scheduled Maintenance', value: 'scheduledMaintenance' },
							{ display: 'Equipment Issue', value: 'issue' },
						]}
					/>

					{maintenanceStatus !== 'operational' && (
						<FormTextArea
							{...this.getInputProps('maintenanceNote')}
							label={'Type of maintenance or issue'}
							gridProps={{ xs: 12 }}
						/>
					)}

					<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
						<Button
							variant="contained"
							color="primary"
							className={classes.addButton}
							onClick={this.submitAddMaintenance}
							disabled={isSavingMaintenance}
						>
							Save Truck Maintenance
						</Button>

						<Zoom
							in={isSavingMaintenance}
							style={{ transitionDelay: isSavingMaintenance ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingMaintenanceSuccessful}
							style={{ transitionDelay: savingMaintenanceSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Save Successful.</span>
							</div>
						</Zoom>
					</Grid>
				</Grid>
			</form>
		);
	};
}

MaintenanceUpdateDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	unavailableTruck: PropTypes.object,
	shiftMap: PropTypes.object,
	equipmentMap: PropTypes.object,
	onRefreshData: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles, { withTheme: true }), AuthUserContainer])(
	MaintenanceUpdateDialog
);
